<template>
  <el-container class="layout-container">
    <el-aside width="200px" class="sidebar">
      <div class="logo">HYDEX系统</div>
      <el-menu :default-active="activeMenu" background-color="#304156" text-color="#bfcbd9" active-text-color="#409EFF" router>
        <template v-for="menu in menuList">
          <el-submenu v-if="menu.children && menu.children.length" :index="menu.path" :key="menu.id">
            <template slot="title">
              <i v-if="menu.icon" :class="menu.icon"></i>
              <span>{{ menu.menuName }}</span>
            </template>
            <el-menu-item v-for="child in menu.children" :index="child.path" :key="child.id">
              <i v-if="child.icon" :class="child.icon"></i>
              <span slot="title">{{ child.menuName }}</span>
            </el-menu-item>
          </el-submenu>

          <el-menu-item v-else :index="menu.path" :key="menu.id">
            <i v-if="menu.icon" :class="menu.icon"></i>
            <span slot="title">{{ menu.menuName }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </el-aside>

    <el-container>
      <el-header class="header">
        <div class="header-right">
          <el-dropdown @command="handleCommand">
            <span style="color: aliceblue">
              {{ userInfo ? userInfo.username : '' }}<i class="el-icon-arrow-down el-icon--right" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>

      <el-main>
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { getMenusByRoleId } from '@/api/menu'

export default {
  name: 'Layout',
  data() {
    return {
      menuList: []
    }
  },
  computed: {
    activeMenu() {
      return this.$route.path
    },
    userInfo() {
      return this.$store.state.userInfo
    }
  },

  // ✅ 关键修复：必须加 async + await，否则永远拿不到 roleId
  async created() {
    // 1. 等待用户信息获取完成
    await this.$store.dispatch('getUserInfo')

    // 2. 此时 roleId 一定有值
    const roleId = localStorage.getItem('roleId')
    console.log('✅ roleId =', roleId)

    // 3. 获取菜单
    this.loadMenuTree(roleId)
  },

  methods: {

    async loadMenuTree(roleId) {
      if (!roleId) {
        console.error(' roleId 为空')
        return
      }

      try {
        const res = await getMenusByRoleId(roleId)
        this.menuList = res.data || []
        // 将菜单数据保存到 Vuex，同时提取权限标识
        this.$store.dispatch('setMenus', this.menuList)
      } catch (error) {
        console.error('获取菜单失败', error)
      }
    },

    handleCommand(command) {
      if (command === 'logout') {
        this.$store.dispatch('logout').then(() => {
          this.$router.push('/login')
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-container {
  height: 100vh;
  .sidebar {
    background: #304156;
    .logo {
      height: 60px;
      line-height: 60px;
      text-align: center;
      color: #fff;
      font-size: 20px;
      font-weight: bold;
      border-bottom: 1px solid #1f2d3d;
    }
  }
  .header {
    background: #304156;
    box-shadow: 0 1px 4px rgba(0,21,41,.08);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .header-right {
      cursor: pointer;
      color: #fff;
    }
  }
}
</style>
